import UserAgentParser from 'ua-parser-js'

/**
 *  Collects the device information to allow preloader to fetch the best assets
 *  and to know some support data.
 */
export default class DeviceInfo {
  /**
   *  Get all data needed
   */
  constructor() {
    this.pixelRatio = this.getDevicePixelRatio()
    this.resolution = this.getResolution()
    this.info = this.getInfo()
    this.aspectRatio = this.getAspectRatio()
  }

  /**
   *  Calculates the device pixel ratio of the device
   *  @return {number}  The device pixel ratio or 1 if no info is available.
   */
  getDevicePixelRatio() {
    return window.devicePixelRatio || 1
  }

  /**
   *  Calculate the screen resolution
   *  @return  {string}  [description]
   */
  getResolution() {
    const screenHeight = window.screen.height
    const heightResolution = screenHeight * this.pixelRatio

    if (heightResolution >= 4320) {
      return '8k'
    } else if (heightResolution >= 2160) {
      return '4k'
    } else if (heightResolution >= 1440) {
      return '1440p'
    } else if (heightResolution >= 1080) {
      return '1080p'
    } else if (heightResolution >= 720) {
      return '720p'
    } else if (heightResolution >= 576) {
      return '576p'
    } else if (heightResolution >= 540) {
      return '540p'
    } else if (heightResolution >= 480) {
      return '480p'
    } else if (heightResolution >= 120) {
      return '120p'
    } else {
      return 'WTF?'
    }
  }

  /**
   *  Get device information from user agent
   *  (UA Parser: https://github.com/faisalman/ua-parser-js)
   *  @return  {object}  Object with device information
   */
  getInfo() {
    const parser = new UserAgentParser()

    return parser.getResult()
  }

  /**
   *  Calculate the screen vertical vs. horizontal ratio
   *  @return  {number}  The ratio.
   */
  getWindowRatio() {
    const windowHeight = window.innerHeight
    const windowWidth = window.innerWidth

    return windowHeight / windowWidth
  }

  /**
   *  Calculate the screen aspect ratio
   *  @return  {string}  The aspect ratio
   */
  getAspectRatio() {
    const screenHeight = window.screen.height
    const screenWidth = window.screen.width
    const heightResolution = screenHeight * this.pixelRatio
    const widthResolution = screenWidth * this.pixelRatio

    const ratio = widthResolution / heightResolution

    if (ratio >= 21.0 / 9.0) {
      return '21:9'
    } else if (ratio >= 16.0 / 9.0) {
      return '16:9'
    } else if (ratio >= 12.0 / 9.0) {
      return '4:3'
    } else {
      return `${widthResolution}:${heightResolution}`
    }
  }

  /**
   *  Return all properties of DeviceInfo as object to be stored
   *  @return  {object}  The device info
   */
  toObject() {
    const deviceInfo = JSON.parse(JSON.stringify({ ...this }))
    return deviceInfo
  }
}
